function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import constants from '../constants/tokenErrorConstants';
import applyReducer from './applyReducer';
const initState = {
  actionsToRetry: [],
  maxTokenRetries: 2,
  pendingTokenRequest: false,
  retryCount: 0
};
const increment = state => _objectSpread(_objectSpread({}, state), {}, {
  pendingTokenRequest: true,
  retryCount: state.retryCount + 1
});
const reset = state => _objectSpread(_objectSpread({}, state), {}, {
  actionsToRetry: initState.actionsToRetry,
  pendingTokenRequest: initState.pendingTokenRequest,
  retryCount: initState.retryCount
});

/**
 * @method retryOnSuccess
 * build an array of redux actions with their requisite arguments to dispatch on a TOKEN_SUCCESS
 */
const retryOnSuccess = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  actionsToRetry: [...state.actionsToRetry, action.retryAction]
});
const reducers = {
  [constants.INCREMENT]: increment,
  [constants.RESET]: reset,
  [constants.RETRY_ON_SUCCESS]: retryOnSuccess
};
export default applyReducer(reducers, initState);